import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SharedPushCapabilitiesHelper } from '../helpers/shared-push-capabilities.helper';

@Injectable({
    providedIn: 'root'
})
export class SharedServiceWorkerService {

    public isServiceWorkerReadySubject$ = new BehaviorSubject<boolean>(false);
    public visibilitychange$ = new BehaviorSubject<boolean>(false);

    private dbName = 'sw-debug';
    private storeName = 'logs';

    constructor() {
        this.registerServiceWorker();
        this.registerVisibilityChangeEvent();
    }

    public isServiceWorkerAvailable(): boolean {
        if (typeof window === 'undefined' || typeof navigator === 'undefined') {
            console.log("ASDF");
            return false;
        }

        // Check support
        return ('serviceWorker' in navigator);
    }

    private registerServiceWorker(): void {
        if (!SharedPushCapabilitiesHelper.isPushSupportedOnThisDevice) return;

        if ('serviceWorker' in navigator) {
            window.addEventListener('load', () => {
                navigator.serviceWorker.register('/sw.js')
                    .then(registration => {
                        console.info('SW registered:', registration);
                        this.isServiceWorkerReadySubject$.next(true);

                    }).catch(err => {
                        console.error('SW registration failed:', err);
                    });
            });
        }
    }

    private registerVisibilityChangeEvent(): void {

        let lastEmit = 0;
        const EMIT_THRESHOLD = 500; // ms

        // used to emitVisibilitychanged only once if both events triggers
        const emitVisibilitychanged = () => {
            const now = Date.now();
            if (now - lastEmit > EMIT_THRESHOLD) {
                lastEmit = now;
                this.visibilitychange$.next(true);
            }
        };

        // check when app gains focus
        document.addEventListener('visibilitychange', () => {

            if (document.visibilityState === 'visible') {
                emitVisibilitychanged();
            }
        });

        window.addEventListener('focus', () => {
            emitVisibilitychanged();
        });
    }

    private openDb(): Promise<IDBDatabase> {
        return new Promise((resolve, reject) => {
            const req = indexedDB.open(this.dbName, 1);
            req.onsuccess = () => resolve(req.result);
            req.onerror = () => reject(req.error);
        });
    }

    public async getLogs(limit = 500): Promise<any[]> {
        const db = await this.openDb();
        return new Promise((resolve, reject) => {
            const tx = db.transaction(this.storeName, 'readonly');
            const store = tx.objectStore(this.storeName);
            const index = store.index('ts');
            const req = index.getAll(); // fetch all logs
            req.onsuccess = () => {
                const result = req.result || [];
                const sorted = result.sort((a: any, b: any) => b.ts - a.ts);
                resolve(sorted.slice(0, limit));
            };
            req.onerror = () => reject(req.error);
        });
    }

}